import React, { useRef, useEffect } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { Container } from './styled';

export function Emoji({ onEmojiSelect, onOutsideClick }) {
    
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    return (
        <Container ref={containerRef}>
            <Picker 
                data={data}
                previewPosition="none"
                searchPosition="none"
                theme="light"
                locale="pt"
                navPosition="top"
                onEmojiSelect={onEmojiSelect}
            />
        </Container>
    );
}